var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgHome4L({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 706,
    height: 482,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      fill: "#97dbcb",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D096FE",
    d: "M29.166 285.169 5.721 460.244c73.159-6.563 125.672-73.402 114.737-146.036l-3.532-23.466-87.76-5.573Z",
    style: {
      fill: "#97dbcb",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ACF6E4",
    d: "M29.166 285.169 5.721 460.244c73.159-6.563 125.672-73.402 114.737-146.036l-3.532-23.466-87.76-5.573Z",
    style: {
      fill: "#97dbcb",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0E0E2C",
    strokeWidth: 5,
    d: "M63.52 327.691c8.132-.506 16.264-1.011 24.497-1.486M102.358 281.762l8.743 69.998-20.713 6.189",
    style: {
      fill: "#97dbcb",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0E0E2C",
    strokeWidth: 5,
    d: "M105.268 305.312c4.429 11.26 18.222 12.364 26.799 2.549",
    style: {
      fill: "#97dbcb",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0E0E2C",
    d: "m103.651 365.221 2.174 1.233-2.796-3.655.622 2.422Zm-18.78 9.83-.381 2.471.381-2.471Zm-13.89-11.28 1.046-2.271-3.336 3.272 2.29-1.001Zm32.67 1.45a253.35 253.35 0 0 1-2.173-1.236v-.001l.002-.002v-.001l-.006.01-.039.066c-.039.064-.103.167-.19.302a19.21 19.21 0 0 1-.811 1.148 21.995 21.995 0 0 1-3.237 3.425c-2.832 2.399-6.822 4.441-11.944 3.649l-.763 4.941c7.015 1.085 12.415-1.79 15.939-4.775a26.958 26.958 0 0 0 3.984-4.213c.449-.589.791-1.091 1.026-1.453a16.164 16.164 0 0 0 .35-.564l.023-.04.008-.013.003-.006.001-.002c.001-.001.001-.002-2.173-1.235Zm-18.398 7.36c-4.01-.62-6.99-2.985-9.037-5.359a21.68 21.68 0 0 1-2.258-3.16 17.574 17.574 0 0 1-.66-1.238l-.025-.053-.003-.007v.001l.001.003v.001c.001.001.002.002-2.29 1.002a282.315 282.315 0 0 0-2.289 1.005l.003.005a.208.208 0 0 1 .005.012l.016.035.051.112a22.434 22.434 0 0 0 .876 1.648 26.675 26.675 0 0 0 2.786 3.899c2.495 2.893 6.459 6.169 12.06 7.035l.764-4.941Zm-14.271-8.81a289.862 289.862 0 0 0-1.044 2.272l.003.001a.068.068 0 0 0 .005.003l.015.007.045.02.15.065c.125.054.303.128.532.219a33.94 33.94 0 0 0 1.959.701 49.694 49.694 0 0 0 7.15 1.727c6.075 1.017 14.602 1.391 24.476-1.144l-1.244-4.843c-9.075 2.33-16.883 1.98-22.406 1.056-2.762-.462-4.947-1.067-6.426-1.55-.74-.241-1.301-.451-1.669-.596-.183-.073-.318-.13-.403-.166l-.088-.038-.015-.007.002.001.001.001c.001 0 .002 0-1.043 2.271Z",
    style: {
      fill: "#97dbcb",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      fill: "#fff7d3",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFECE7",
    d: "M448.859 212.527c2.316 15.292-1.068 35.296-20.427 30.047-4.942-1.32-8.359-5.989-10.245-10.79-2.573-6.553-3.14-13.948-1.446-20.798 1.291-5.274 6.251-17.837 15.267-27.661 1.654-1.819 13.215 16.504 14.058 18.51 1.183 2.85 2.24 6.581 2.793 10.692Z",
    style: {
      fill: "#fff7d3",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      fill: "#bfa1d6",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D096FE",
    fillRule: "evenodd",
    d: "m239.325 99.74-13.76 5.823-4.18 11.504.766 11.727-11.262.097-11.193 3.442-2.233 13.561 6.167 6.953 8.203 3.851 9.163 2.497 8.742-2.258-7.913 6.342-.602 10.077 4.85 8.54 9.431 3.411 9.942-2.399 7.183-7.504 3.13-10.145-3.64-10.695 8.065 6.577 9.292 2.588 9.431-3.136 4.591-8.748 1.602-9.732-4.637-8.757-8.161-5.611-9.925-.238-8.965 3.348 5.475-13.628-5.124-13.896-14.438-3.59Zm-1.45 34.269 10.824 3.697.734 8.58-9.016 3.588-5.91-5.282 3.368-10.583Z",
    clipRule: "evenodd",
    style: {
      fill: "#bfa1d6",
      fillOpacity: 1
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#0E0E2C",
    strokeLinecap: "square",
    strokeWidth: 5,
    d: "M546.959 126.543c-29.925-16.416-68.662-14.746-97.502 4.363-26.714 17.684-43.617 47.182-66.012 70.347-23.019 23.541-52.348 40.533-83.66 48.507-21.356 5.369-49.852 2.703-56.58-18.775-5.617-17.751 9.004-36.649 26.037-43.524 31.703-12.749 71.476 8.081 79.546 41.661 7.968 32.649-11.881 67.331-38.998 86.535-27.116 19.204-84.563 32.898-154.75 22.684"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      fill: "#77c69b",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#64E986",
    rx: 50.824,
    ry: 87.706,
    style: {
      fill: "#77c69b",
      fillOpacity: 1
    },
    transform: "matrix(-.74802 -.66411 .66417 -.7472 324.159 326.485)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C1F9A2",
    d: "m575.198 196.779-6.295-20.713-13.837-16.968-20.35-8.318-21.942.772-21.905 15.858-15.72 25.523-.452 19.529 8.73 17.38 15.939 11.532 18.738 6.142 19.511-1.782 19.864-9.649 13.218-17.8 4.501-21.506Zm-30.949 5.273-20.14 13.738-17.274-11.055 7.864-22.205 18.465-5.448 10.631 12.288.454 12.682Z",
    style: {
      fill: "#c1e4d1",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      fill: "#fae89a",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFB571",
    d: "M444.016 101.856s8.67 5.642 31.792-11.699c14.22-10.665 19.155-34.382 19.745-53.116.37-11.728-4.022-34.03-4.022-34.03l-47.515 98.845Z",
    style: {
      fill: "#fae89a",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      stroke: "#e6abab",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFBABA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "m591.829 133.123 68.159-30.408 14.388 28.395-72.239 35.061-10.308-33.048Z",
    style: {
      stroke: "#e6abab",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      fill: "#518d64",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#29AB87",
    d: "M573.922 147.61c1.869-.013 12.192 2.143 58.556-11.567 28.514-8.432 54.433-41.118 66.253-70.153 7.401-18.176 5.237-32.924 7.23-45.577-20.342 2.003-39.457 7.576-58.99 16.215-28.132 12.444-50.529 32.802-55.551 39.419-8.509 11.21-19.366 71.677-17.498 71.663Z",
    style: {
      fill: "#518d64",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#EFF3EE",
    rx: 20.807,
    ry: 18.559,
    style: {
      mixBlendMode: "multiply"
    },
    transform: "matrix(.74822 .6654 .6586 -.74219 349.792 149.62)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgHome4L);
export default __webpack_public_path__ + "static/media/bg_home4_l.5ed7c14807c4d628d0e9f78f14ee0b58.svg";
export { ForwardRef as ReactComponent };